import { createRoot } from 'react-dom/client'
import TextType from '../components/TextType'
import StaggeredMenu from '../components/StaggeredMenu'
import TiltedSectionCard from '../components/TiltedSectionCard'
import DiagonalCollage from '../components/DiagonalCollage'
import { initSmoothScroll, destroySmoothScroll } from '../lib/smoothScroll'

const registry = { TextType, StaggeredMenu, TiltedSectionCard, DiagonalCollage }
const mountedRoots = new WeakMap()

function mountReactComponents() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  document.querySelectorAll('[data-react-component]').forEach((el) => {
    if (mountedRoots.has(el)) return

    const name = el.dataset.reactComponent
    const Component = registry[name]
    if (!Component) return

    if (prefersReducedMotion && el.dataset.reducedMotionSkip === 'true') return

    const props = el.dataset.reactProps ? JSON.parse(el.dataset.reactProps) : {}
    const root = createRoot(el)
    mountedRoots.set(el, root)
    root.render(<Component {...props} />)
  })
}

document.addEventListener('turbo:load', mountReactComponents)
document.addEventListener('DOMContentLoaded', mountReactComponents)

document.addEventListener('turbo:load', initSmoothScroll)
document.addEventListener('DOMContentLoaded', initSmoothScroll)
document.addEventListener('turbo:before-cache', destroySmoothScroll)
